export default __webpack_public_path__ + "static/media/womenLongHijab.428be97f.svg";